import React from 'react';

export const CampaignsUsingCellRenderer = ({ data: { isDefault, numberOfCampaignsUsing } }) =>
    isDefault ? <>-</> : <>{numberOfCampaignsUsing}</>;
